module.exports = __webpack_public_path__ + "static/img/19.a6c0e6bd.png";